<template>
  <el-input
    v-model="searchKeyword"
    class="search-input"
    :placeholder="t('common.fuzzy_search')"
    :style="{ width: width }"
    clearable
    :clear-icon="componentCloseIcon"
  >
    <template #prefix>
      <Icon
        icon="sky:ic-search-plus"
        class="size-5"
      />
    </template>
  </el-input>
</template>

<script setup lang="ts">
import { h, watch } from 'vue'
import { useDebounceFn } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'

const { t } = useI18n()

const searchKeyword = defineModel<string>({ default: '' })

const emit = defineEmits<{
  (e: 'search', value: string): void
}>()

type Props = {
  width?: string
}

const props = withDefaults(defineProps<Props>(), {
  width: '260px',
})

const componentCloseIcon = h(Icon, { icon: 'sky:ic-close-fill', class: 'size-4' })

const debouncedSearch = useDebounceFn(() => {
  emit('search', searchKeyword.value || '')
}, 300)

watch(searchKeyword, () => {
  debouncedSearch()
})
</script>

<style scoped>
.search-input :deep(.el-input__inner) {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
}

/* 清除按钮热区 24px */
.search-input :deep(.el-input__clear) {
  min-width: 24px;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
</style>
